import React from 'react';
import styled from 'styled-components';

import { CompanyLogo } from '../icons';

const LogoContainer = styled.div`
  position: absolute;
  top: 0;
  ${({ position }: Props) => {
    switch (position) {
      case 'left':
        return `
          left: 70px;
        `;
      case 'right':
        return `
          right: 70px;
        `;
      default:
        return `
          left: 50%;
          transform: translateX(-50%);
        `;
    }
  }}
  z-index: 1;
`;

type Props = {
  position?: 'left' | 'right'
}

const Logo = ({ position }: Props) => {
  return (
    <LogoContainer position={position}>
      <CompanyLogo />
    </LogoContainer>
  );
};

export default Logo;